// extracted by mini-css-extract-plugin
module.exports = {"footerParent":"UserAdd_footerParent__1kbTT","centeredContent":"UserAdd_centeredContent__25AFT","footer":"UserAdd_footer__3nTYu","inputHolder":"UserAdd_inputHolder__1sEZo"};